import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { of, Subject } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { ProfessionalService } from '../../../shared/services/professional.service';
import { FileService } from '../../../shared/services/file.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-list-inactive-professionals',
  templateUrl: './list-inactive-professionals.component.html',
  styleUrls: ['./list-inactive-professionals.component.scss'],
})
export class ListInactiveProfessionalsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private searchTerm = '';
  private searchSubject = new Subject<string>();
  isLoading = false;
  photoUrls: Record<string, SafeUrl> = {};

  totalProfessionals = 0;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25, 50];

  displayedColumns: string[] = [
    'action',
    'image',
    'name',
    'document',
    'email',
    'licenseNumber',
    'cellphone',
    'status',
  ];

  dataSource: MatTableDataSource<any>;

  constructor(
    private professionalService: ProfessionalService,
    private fileService: FileService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.searchSubject.pipe(debounceTime(400), distinctUntilChanged()).subscribe((term) => {
      this.searchTerm = term;
      this.pageIndex = 0;
      this.getAll();
    });

    this.getAll();
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchSubject.next(filterValue.trim());
  }

  goToUserEdit(id: string) {
    this.router.navigate(['/professionals', id]);
  }

  reactivate(id: string) {
    this.professionalService.toggleActive(id, true).subscribe({
      next: () => {
        this.snackbar.open('Profissional reativado com sucesso', 'OK', { duration: 3000 });
        this.getAll();
      },
      error: () => {
        this.snackbar.open('Não foi possível reativar o profissional', 'OK', { duration: 3000 });
      },
    });
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.getAll();
  }

  getAll() {
    this.isLoading = true;
    this.photoUrls = {};
    this.professionalService.getAll(undefined, this.pageIndex + 1, this.pageSize, this.searchTerm || undefined, false).subscribe((result: any) => {
      this.totalProfessionals = result.total ?? 0;
      const professionals = result.professionals.map((professional: any) => ({
        id: professional._id,
        name: professional.fullname,
        document: professional.document,
        email: professional.email,
        licenseNumber: professional.licenseNumber,
        cellphone: professional.cellphone,
        status: professional.status,
        createdAt: professional.createdAt,
        photoFileId: professional.photoFileId ?? null,
      }));
      this.dataSource = new MatTableDataSource<any>(professionals);
      this.isLoading = false;

      professionals.forEach((p: any) => {
        if (p.photoFileId) {
          this.fileService.getImageUrl(p.photoFileId)
            .pipe(catchError(() => of(null)))
            .subscribe((url: string | null) => {
              if (url) {
                this.photoUrls[p.id] = this.sanitizer.bypassSecurityTrustUrl(url);
                this.cdr.detectChanges();
              }
            });
        }
      });
    }, () => {
      this.isLoading = false;
    });
  }

  getPhotoSrc(id: string): SafeUrl | string {
    return this.photoUrls[id] || 'assets/img/user/user1.jpg';
  }

  getNameStatus(status: string) {
    switch (status) {
      case 'APPROVED': return 'Aprovado';
      case 'REJECTED': return 'Rejeitado';
      case 'PENDING': return 'Pendente';
      default: return status;
    }
  }
}
